import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
//import TimePicker from 'react-time-picker';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Button, Container, Grid, IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { pad } from "../../functions/default";
import { FullPageSpinner } from "../lib";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import MessageBox from '../shared/components/MessageBox';
import ResponsiveDialog from '../shared/components/ResponsiveDialog';

function Timetracking(props) {
  const { t } = useTranslation();
  const { client, accessToken } = props;
  const [today, setToday] = useState(new Date());
  const [server, setServer] = useState(new Date());
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();
  const [openVert, setOpenVert] = useState(0)
  const [vert, setVert] = useState({})
  const [vertKst, setVertKst] = useState([])
  const [vertZus, setVertZus] = useState([])
  const [vertEnde, setVertEnde] = useState("")
  const [rest, setRest] = useState("00:00")
  const [gesamt, setGesamt] = useState("00:00")
  // eslint-disable-next-line
  const [arb, setArb] = useState("00:00")
  const [restmin, setRestmin] = useState(0)
  const [gesamtmin, setGesamtmin] = useState(0)
  const [arbmin, setArbmin] = useState(0)
  const [pausemin, setPausemin] = useState(0)
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [dynamischeMessageBoxOpen, setDynamischeMessageBoxOpen] = useState(false);
  const [stempelTyp, setStempelTyp] = useState('');
  const [messageBoxFrage, setMessageBoxFrage] = useState('');
  const [zeitarten, setZeitarten] = useState([]);
  const [zeitart, setZeitart] = useState("00");
  const [zeitartaktiv, setZeitartaktiv] = useState("");
  const [infoText, setInfoText] = useState(false);
  const [info, setInfo] = useState(false);
  const rb = useRef(true);
  useEffect(() => {
    const payload = {
      "mandant": client,
      "program": "PMBZE0",
      "statement": "LETZTE_ZEITEN",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postLaden, errorCb);
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    const myInterval = setInterval(() => {
      setToday(new Date());
      if (server) {
        var tmpdate = server
        tmpdate.setTime(tmpdate.getTime() + 1000)
        rb.current = !rb.current
        setServer(tmpdate)
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    }
  }, [])
  const postLaden = (response) => {
    setIsLoading(false)
    if (response.status === 200) {
      setData(response.data)
      if (response.data.zeitarten) {
        setZeitarten(response.data.zeitarten)
      }
      setZeitartaktiv(response.data.zeitartaktiv)
      var tmpdate = server;
      tmpdate.setFullYear(response.data.serverjahr)
      tmpdate.setMonth(response.data.servermonat)
      tmpdate.setDate(response.data.servertag)
      tmpdate.setHours(response.data.serverstunden)
      tmpdate.setMinutes(response.data.serverminuten)
      tmpdate.setSeconds(response.data.serversekunden)
      setServer(tmpdate)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
        navigate(-1);
      }
    }
  }
function errorCb(){
  setIsLoading(false)
  showErrorMessage(t("Es konnte keine Verbindung hergestellt werden"));
  navigate(-1);
}
  const newTimerecordCb = (response) => {
    setIsSending(false)
    setStempelTyp('');
    if (response.status === 200) {
      if (response.data.vertaktiv === "1") {
        setVert(response.data.vert)
        setVertKst(response.data.vertkst)
        setVertZus(response.data.vertzus)
        setArb(response.data.arbstd)
        setGesamt(response.data.gesamtstd)
        setRest(response.data.reststd)
        setRestmin(response.data.restmin)
        setGesamtmin(response.data.gesamtmin)
        setArbmin(response.data.arbmin)
        setVertEnde(response.data.vertende)
        if (response.data.pause) { setPausemin(response.data.pause) }
        showSuccessMessage(response.data.message)
        setOpenVert(1)
      } else {
        if (response.data) setData(response.data)
        showSuccessMessage(response.data.message)
      }
        var tmpdate = server;
        tmpdate.setFullYear(response.data.serverjahr)
        tmpdate.setMonth(response.data.servermonat)
        tmpdate.setDate(response.data.servertag)
        tmpdate.setHours(response.data.serverstunden)
        tmpdate.setMinutes(response.data.serverminuten)
        tmpdate.setSeconds(response.data.serversekunden)
        setServer(tmpdate)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      }
    }
  }
  const messageBoxResult = (result) => {
    if (result === 'YES') {
      stempeln();
    } else {
      setStempelTyp('');
    }
    setMessageBoxOpen(false);
    setDynamischeMessageBoxOpen(false);
  }
  function stempeln() {
    const payload = {
      "mandant": client,
      "program": "PMBZE0",
      "statement": "STEMPELN",
      "stempeltyp": stempelTyp,
      "newversion": "1",
      "zeitart": zeitart,
      "timestamp": new Date().getTime(),
      "timezone": new Date().getTimezoneOffset()
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    setIsSending(true)
    apiRequest('POST', 'daten', payload, headers, newTimerecordCb)
  }
  function postPruefen(response) {
    setIsSending(false)
    if (response.status === 200) {
      if (response.data.frage && response.data.frage !== "") {
        setMessageBoxFrage(response.data.frage);
        setDynamischeMessageBoxOpen(true);
      } else {
        setMessageBoxOpen(true);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      }
    }
  }
  const handleClockInClick = (typ) => {
    setIsSending(true)
    setStempelTyp(typ);
    const payload = {
      "mandant": client,
      "program": "PMBZE0",
      "statement": "PRUEFEN",
      "stempeltyp": typ,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, (r) => postPruefen(r));
  }
  function Aktion(aktion) {
    if (aktion === "reset") {
      setGesamt(InStd(Number(arbmin) + Number(pausemin)))
      setGesamtmin(Number(arbmin) + Number(pausemin))
      setRest(InStd(Number(arbmin) + Number(pausemin)))
      setRestmin(Number(arbmin) + Number(pausemin))
      if (vertKst && vertKst.length > 0) {
        var tmpliste = [...vertKst]
        vertKst.forEach((item, index) => {
          tmpliste[index].std = "00:00"
          tmpliste[index].min = "0"
        })
        setVertKst(tmpliste)
      }
      if (vertZus && vertZus.length > 0) {
        tmpliste = [...vertZus]
        vertZus.forEach((item, index) => {
          tmpliste[index].std = "00:00"
          tmpliste[index].min = "0"
        })
        setVertZus(tmpliste)
      }
    }
    if (aktion === "pause") {
      Reset()
    }
    if (aktion === "ende") {
      Speichern()
    }
    if (aktion === "speichern") {
      Speichern()
    }
  }
  function ChangeKst(value, index) {
    var tmpliste = [...vertKst]
    tmpliste[index].std = value
    var min = InMin(value)
    tmpliste[index].min = min
    setVertKst(tmpliste)
    Berechnen()
  }
  function ChangeZus(value, index) {
    var tmpliste = [...vertZus]
    tmpliste[index].std = value
    var min = InMin(value)
    tmpliste[index].min = min
    setVertZus(tmpliste)
    Berechnen()
  }
  function InMin(time) {
    var pos = time.indexOf(":")
    var h = time.substr(0, pos)
    var min = time.substr(pos + 1)
    time = Number(min) + Number(h) * 60
    return time
  }
  function InStd(time) {
    var h = Math.trunc(Number(time) / 60)
    var min = Math.abs(Number(time) % 60)
    var htime = pad(Math.abs(h), 2) + ":" + pad(min, 2)
    if (Number(time < 0)) htime = "-" + htime
    return htime
  }
  function Berechnen() {
    var time = arbmin
    var tmparbmin = arbmin
    if (vertKst && vertKst.length > 0) {
      var tmpliste = [...vertKst]
      vertKst.forEach((item, index) => {
        time = time - tmpliste[index].min
      })
    }
    if (vertZus && vertZus.length > 0) {
      tmpliste = [...vertZus]
      vertZus.forEach((item, index) => {
        if (item.key === "PAUS") {
          var wert = Number(item.min) - Number(pausemin)
          tmparbmin = Number(tmparbmin) - wert
          time = time - wert
        }
      })
    }
    setGesamtmin(tmparbmin)
    setRestmin(time)
    setGesamt(InStd(tmparbmin))
    setRest(InStd(time))
  }
  function Reset() {
    setOpenVert(0)
    const payload = {
      "mandant": client,
      "program": "PMBZE0",
      "statement": "LETZTE_ZEITEN",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postLaden);
  }
  function Speichern() {
    if (Number(restmin !== 0)) {
      if (Number(restmin < 0)) showErrorMessage(t("Sie haben zu viele Stunden verteilt. Bitte korrigieren Sie Ihre Eingaben"))
      if (Number(restmin > 0)) showErrorMessage(t("Es wurden noch nicht alle Stunden verteilt. Bitte korrigieren Sie Ihre Eingaben"))
      return
    }
    var fehler = 0
    if (vertZus && vertZus.length > 0) {
      vertZus.forEach((item, index) => {
        if (item.key !== "PAUS" && Number(item.min) > gesamtmin) {
          showErrorMessage(t("Die Stunden von ") + item.bez + " darf die Gesamtzeit nicht überschreiten. Bitte korrigieren Sei Ihre Eingaben")
          fehler = 1
          return
        }
      })
    }
    if (fehler === 1) return
    const payload = {
      "mandant": client,
      "program": "PMBZE0",
      "statement": "SPEICHERN_VERT",
      "vertkst": vertKst,
      "vertzus": vertZus,
      "kstlen": (vertKst && vertKst.length > 0) ? vertKst.length : "0",
      "zuslen": (vertZus && vertZus.length > 0) ? vertZus.length : "0",
      "zr": vert.datum,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, (r) => postVert(r));
  }
  function postVert(response) {
    setIsSending(false)
    if (response.status === 200) {
      showSuccessMessage(t("Kostenstellenverteilung gespeichert"))
      setOpenVert(0)
      setData(response.data)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      }
    }
  }
  if (isLoading || data === null) {
    return <LoadingComponent />
  }
  function displayTimeRecords() {
    if (!data || !data.timerecord) return (
      <TableRow key="key0">
        <TableCell>-</TableCell>
        <TableCell>-</TableCell>
        {zeitartaktiv === "J" &&
          <TableCell>-</TableCell>
        }
      </TableRow>
    )
    return (
      data.timerecord.map((dataObject, index) => {
        const text = dataObject.text;
        const date = dataObject.date;
        const za = dataObject.zeitart;
        var backColor = ""
        if (dataObject.state === 'danger') backColor = "rgb(244, 067, 054, 0.8)"
        if (dataObject.state === 'warning') backColor = "rgb(253, 200, 69, 0.8)"
        if (dataObject.state === 'success') backColor = "rgb(076, 175, 080, 0.5)"
        //const state = dataObject.state === '' ? '' : 'table-'+dataObject.state; //  data-toggle="modal" data-target="#exampleModal"
        return (
          <TableRow style={{ backgroundColor: backColor }} key={index} onClick={() => console.log('clicked ' + dataObject.date)}>
            <TableCell>{date}</TableCell>
            <TableCell>{text}</TableCell>
            {zeitartaktiv === "J" &&
              <TableCell>{za}</TableCell>
            }
          </TableRow>
        );
      })
    )
  }
  function StundenVert() {
    return (
      <ResponsiveDialog
        title={t("Kostenstellenverteileung")}
        open={openVert === 1}
        setOpen={(o) => Reset()}
        actionButton={
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item xs={12} md={2}>
              <Button
                color="primary"
                fullWidth
                variant="outlined"
                onClick={() => Aktion("reset")}
              >
                {t("Zurücksetzen")}
              </Button>
            </Grid>
            {vertEnde === "J" &&
              <Fragment>
                <Grid item xs={12} md={2}>
                  <Button
                    color="primary"
                    fullWidth
                    variant="outlined"
                    onClick={() => Aktion("pause")}
                  >
                    {t("Pause")}
                  </Button>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    color="primary"
                    fullWidth
                    variant="outlined"
                    onClick={() => Aktion("ende")}
                  >
                    {t("Arbeitsende")}
                  </Button>
                </Grid>
              </Fragment>
            }
            {vertEnde !== "J" &&
              <Grid item xs={12} md={2}>
                <Button
                  color="primary"
                  fullWidth
                  variant="outlined"
                  onClick={() => Aktion("speichern")}
                >
                  {t("Speichern")}
                </Button>
              </Grid>
            }
          </Grid>
        }
      >
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} md={8}>
            <Box p={2}>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell colspan={2}>
                        <Typography align="center">
                          {t("Informationen")}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        {t("Mitarbeiter")}
                      </TableCell>
                      <TableCell>
                        {vert.name}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("Datum")}
                      </TableCell>
                      <TableCell>
                        {vert.datum}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("Beginn")}
                      </TableCell>
                      <TableCell>
                        {vert.von}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("Ende")}
                      </TableCell>
                      <TableCell>
                        {vert.bis}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("Arbeitszeit")}
                      </TableCell>
                      <TableCell>
                        {gesamt}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {t("Zu Verteilen")}
                      </TableCell>
                      <TableCell>
                        {rest}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          {vertKst && vertKst.length > 0 &&
            <Grid item xs={12} md={8}>
              <Box p={2}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell colspan={2}>
                          <Typography align="center">
                            {t("Kostenstellen")}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {vertKst.map((item, index) => {
                        return (
                          <TableRow>
                            <TableCell style={{ width: "60%" }}>
                              {item.bez}
                            </TableCell>
                            <TableCell style={{ width: "40%" }}>
                              <TextField
                                fullWidth
                                type="time"
                                value={item.std}
                                onChange={(e) => ChangeKst(e.target.value, index)}
                              />
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          }
          {vertZus && vertZus.length > 0 &&
            <Grid item xs={12} md={8}>
              <Box p={2}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell colspan={2}>
                          <Typography align="center">
                            {t("Zusatz/Zuschläge")}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {vertZus.map((item, index) => {
                        return (
                          <TableRow>
                            <TableCell style={{ width: "60%" }}>
                              {item.bez}
                            </TableCell>
                            <TableCell style={{ width: "40%" }}>
                              <TextField
                                fullWidth
                                type="time"
                                value={item.std}
                                onChange={(e) => ChangeZus(e.target.value, index)}
                              />
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          }
        </Grid>
      </ResponsiveDialog>
    )
  }
  return (
    <Fragment>
      <ResponsiveDialog
        title={t("Hinweis Zeitarten")}
        open={infoText}
        setOpen={(o) => setInfoText(false)}
      >
        <Box p={2}>
        </Box>
      </ResponsiveDialog>
      <ResponsiveDialog
        title={t("Hinweis Datum/Uhrzeit")}
        open={info}
        setOpen={(o) => setInfo(false)}
      >
        <Box p={2}>
          <Typography>
            {"Der angezeigte Zeitpunkt wird auf den ectool Servern (Standort:Deutschland) ermittelt und für Ihre Buchung verwendet. Dieser kann von Ihrem Gerät oder Standort abweichen."}
          </Typography>
        </Box>
      </ResponsiveDialog>
      {StundenVert()}
      <div className="mt-2 col-12 col-md-8 mx-auto">
        {/* <Typography color="primary" variant="h4">{t("Zeiterfassung")}</Typography> */}
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
            <Grid container alignItems="center" spacing={1} justifyContent="center">
              <Grid item xs={12}>
                <Box p={2}>
                  <Container >
                    <Box pt={1}>
                      <Grid container justifyContent="center">
                        <Grid item xs={12}>
                          <Typography variant="h6">
                            {(server.getDay() === 0 ? t("Sonntag")
                              : server.getDay() === 1 ? t("Montag")
                                : server.getDay() === 2 ? t("Dienstag")
                                  : server.getDay() === 3 ? t("Mittwoch")
                                    : server.getDay() === 4 ? t("Donnerstag")
                                      : server.getDay() === 5 ? t("Freitag")
                                        : server.getDay() === 6 ? t("Samstag")
                                          : "")
                              + ", " + pad(server.getDate(), 2) + "." + pad(server.getMonth() + 1, 2) + "." + server.getFullYear().toString()
                            }
                          </Typography>
                        </Grid>
                        {Math.abs(server.getTime() - today.getTime()) > 300000 &&
                          <Grid item>
                            <IconButton
                              color="primary"
                              size="small"
                              style={{
                                visibility: "hidden"
                              }}
                            >
                              <InfoIcon />
                            </IconButton>
                          </Grid>
                        }
                        <Grid item>
                          <Grid container>
                            <Grid item>
                              <Typography variant="h2" display="inline">
                                {pad(server.getHours(), 2)}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="h2" display="inline" style={rb.current ? { visibility: "hidden" } : {}}>
                                {":"}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="h2" display="inline">
                                {pad(server.getMinutes(), 2)}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        {Math.abs(server.getTime() - today.getTime()) > 60000 &&
                          <Grid item>
                            <IconButton
                              size="small"
                              color="primary"
                              variant=""
                              onClick={() => setInfo(true)}
                            >
                              <InfoIcon
                                fontSize="medium"
                              />
                            </IconButton>
                          </Grid>
                        }
                      </Grid>
                    </Box>
                  </Container>
                </Box>
              </Grid>
              {zeitarten && zeitarten.length > 0 &&
                <Grid item xs={12}>
                <Box p={2}>
                  <TextField
                    id="zeitarten"
                    label={t("Auswahl Zeitart")}
                    select
                    size="small"
                    fullWidth
                    value={zeitart}
                    onChange={(e) => setZeitart(e.target.value)}
                    variant="outlined"
                  >
                    {zeitarten.map((item, index) => (
                      <MenuItem key={index} value={item.key}>{item.bez}</MenuItem>
                    ))}
                  </TextField>
                  </Box>
                </Grid>
              }
              {(zeitartaktiv === "J" && 1 === 2) &&
                <Grid item xs={12}>
                  <Box p={2}>
                    {"Info zu Zeitarten und Wechsel"}
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => setInfoText(true)}
                    >
                    <HelpIcon fontSize="small" />
                  </IconButton >
                  </Box>
                </Grid>
              }
              {data?.buttons?.map((row, count) => (
                <Grid item xs={12} sm={6} key={count}>
                  <Box px={2}>
                  <Button color="primary" variant="contained" onClick={() => handleClockInClick(row.aktion, row.bez)} fullWidth  >{row.bez}</Button>
                  </Box>
                </Grid>
              ))}
              <Grid item xs={12}>
                <Box p={2}>
                  <Paper>
                    <Box p={2}>
                      <Typography variant="h5">{t("Ihre Zeitkarte")}</Typography>
                    </Box>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t("Datum")}</TableCell>
                          <TableCell>{t("Zeiten")}</TableCell>
                          {zeitartaktiv === "J" &&
                            <TableCell>{t("Zeitart")}</TableCell>
                          }
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {displayTimeRecords()}
                      </TableBody>
                    </Table>
                  </Paper>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box p={2}>
                  <Paper>
                    <Box p={2}>
                      <Typography variant="h5">{t("Ihre Salden")}</Typography>
                    </Box>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t("Konto")}</TableCell>
                          <TableCell align="right">{t("Heute")}</TableCell>
                          <TableCell align="right">{t("Geplant bis 31.12.")}</TableCell>
                          <TableCell align="right">{t("Endstand zum 31.12.")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data?.salden?.map((row, count) => (
                          <TableRow key={count}>
                            <TableCell component="th" scope="row">
                              {row.text}
                            </TableCell>
                            <TableCell align="right">{row.current}</TableCell>
                            <TableCell align="right">{row.planed}</TableCell>
                            <TableCell align="right">{row.final}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <MessageBox
          title={t("Hinweis")}
          text={t("Damit wird eine Stempelung zur aktuellen Uhrzeit eingebucht. Möchten Sie das wirklich?")}
          buttons="YESNO"
          onClose={() => setMessageBoxOpen(false)}
          open={messageBoxOpen}
          handleResponse={messageBoxResult}
        />
        <MessageBox
          title={t("Hinweis")}
          text={messageBoxFrage}
          buttons="YESNO"
          onClose={() => setDynamischeMessageBoxOpen(false)}
          open={dynamischeMessageBoxOpen}
          handleResponse={messageBoxResult}
        />
        {isSending && <FullPageSpinner />}
      </div>
    </Fragment >
  );
}
export default Timetracking;
